import React, { useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {
  Button,
  FormControl,
  FormLabel,
  Grid,
  Link,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import "./messages.css";
import { animated, useSpring } from "react-spring";
import moment from "moment";
import "../checkAvailability/Checkavailability.css";
import useOrderDetailsData from "./customHook";
import templeJson from "../../config/temple";

export default function Payment() {
  const paymentId = localStorage.getItem("paymentId");
  const { getOrderDetails, processing, orderDetails, navigate, searchParams } =
    useOrderDetailsData();
  const payeeDetails = orderDetails && orderDetails?.payout;

  useEffect(() => {
    if (paymentId) {
      getOrderDetails(paymentId);
    }
  }, []);

  const animationProps = useSpring({
    to: async (next) => {
      while (processing) {
        await next({ opacity: 1, transform: "translateY(0%)" });
        await next({ opacity: 0.5, transform: "translateY(-10%)" });
        await next({ opacity: 1, transform: "translateY(0%)" });
      }
    },
    from: { opacity: 0, transform: "translateY(-20%)" },
  });

  return (
    <section className="w-100">
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">Payment Status</h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">Payment Status</li>
        </ol>
      </Container>

      <Grid className="row mb-5 ">
        <Container component="main" maxWidth="sm">
          <Box component="form" noValidate sx={{ mt: 3 }} align="center">
            {searchParams.get("success") ? (
              <FormControl>
                {orderDetails &&
                orderDetails?.payment_status === "SUCCESS" &&
                !processing ? (
                  <>
                    <Grid className="container py-5">
                      <Grid className="row d-flex justify-content-center align-items-center">
                        <Grid className="receipt-bg">
                          <Grid className="d-flex justify-content-between mb-5 header-bdr">
                            <Grid className="logo1">
                                <img
                                  src={
                                    process.env.REACT_APP_S3_BASE_URL +
                                    "/api/images/logo.png"
                                  }
                                  alt="logo"
                                />
                            </Grid>
                            <Grid className="receipt-header">
                              <h2>{templeJson["templeName"]}</h2>
                              <p>(A tax exempt non-profit organization)</p>
                              <h3>
                                {templeJson["Footer"]?.ContactInfo?.address}
                                <br />
                                Phone:{" "}
                                {templeJson["Footer"]?.ContactInfo?.phone}
                              </h3>
                            </Grid>
                            <Grid>
                              {templeJson["Header"]?.style === 2 ? (
                                ""
                              ) : (
                                <Grid className="logo2">
                                  <img
                                    src={
                                      process.env.REACT_APP_S3_BASE_URL +
                                      "/api/images/logo2.png"
                                    }
                                    alt="logo"
                                  />
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                          <p>
                            Dear{" "}
                            {payeeDetails?.sankalpmembers
                              ? `${payeeDetails?.sankalpmembers[0]?.first_name} ${payeeDetails?.sankalpmembers[0]?.last_name}`
                              : `${payeeDetails?.first_name} ${payeeDetails?.last_name}`}
                            ,
                          </p>
                          <p><span>Thank you for ordering Puja/Donation.Your Payment ID is <strong>{orderDetails?.payment_id}</strong> and your receipt number is <strong>{orderDetails?.receipt_number}</strong>.</span></p><br/>

                          <Table responsive striped className="trustee">
                            <TableHead>
                              <TableRow>
                                <TableCell><strong>Item</strong></TableCell>
                                <TableCell><strong>Date</strong></TableCell>
                                <TableCell><strong>Qty</strong></TableCell>
                                <TableCell><strong>Unit Price</strong></TableCell>
                                <TableCell><strong>Amount</strong></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {orderDetails?.line_items?.map(
                                (service, index) => (
                                  <TableRow key={index}>  
                                    <TableCell>
                                      {service?.name}
                                      {/* <span>Book online - attend in person</span> */}
                                    </TableCell>
                                    <TableCell>
                                      {service?.type == 5
                                        ? moment(service?.date)
                                            .tz("America/New_York")
                                            .format("M/DD/YYYY")
                                        : moment(service?.date)
                                            .utc()
                                            .format("M/DD/YYYY")}
                                    </TableCell>
                                    <TableCell>{service?.quantity}</TableCell>
                                    <TableCell>
                                      $
                                      {Number(service?.price).toLocaleString(
                                        "en-US"
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      $
                                      {(
                                        service?.price * service?.quantity
                                      ).toLocaleString("en-US")}
                                    </TableCell>
                                  </TableRow>
                                )
                              )}

                              <TableRow>
                                <TableCell colspan="5" className="total-sum">
                                  Total Amount : $
                                  {Number(orderDetails?.amount).toLocaleString(
                                    "en-US"
                                  )}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                          <p className="mt-4">
                            <strong>Attention:</strong> If the service booked
                            allows in person attendance, Please carry copy of
                            email / printed copy of the receipt to the temple
                          </p>
                          <p>If you have any questions with your order, please contact <a href={`mailto:${templeJson["Footer"]?.ContactInfo?.email}`}>{templeJson["Footer"]?.ContactInfo?.email}</a>.</p>
                          <p>
                            May the blessings of Goddess{" "}
                            {templeJson["templeName"]} be with us always
                          </p>
                          <p className="regards">
                            {templeJson?.templeName}
                            <br />
                            {templeJson["Footer"]?.ContactInfo?.address}
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <React.Fragment>
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      className="mt-2 text-info"
                    >
                      Payment in Progress ...
                    </FormLabel>
                    <Typography variant="body1" className="mt-2" align="center">
                      Please wait while we process your payment. Don't press
                      back or refresh the page while processing payment.
                    </Typography>
                    <animated.div style={animationProps}>
                      <Typography
                        variant="body1"
                        className="mt-2"
                        align="center"
                      >
                        Processing...
                      </Typography>
                    </animated.div>
                  </React.Fragment>
                )}
              </FormControl>
            ) : (
              <>
                <React.Fragment>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    className="mt-2 text-danger"
                  >
                    Payment Unsuccessful!
                  </FormLabel>
                  <Typography variant="body1" className="mt-2" align="center">
                    Your payment was unsuccessful. Please try again.
                  </Typography>
                </React.Fragment>
                {!processing && (
                  <Grid
                    container
                    justifyContent="center"
                    className="btn-align mt-4"
                  >
                    <Button
                      variant="contained"
                      onClick={() => navigate("/")}
                    >
                      Back to Home
                    </Button>
                  </Grid>
                )}
              </>
            )}
            <CssBaseline />
            <Box sx={{ marginTop: 2 }}></Box>
          </Box>
        </Container>
      </Grid>
    </section>
  );
}
